import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractHttpService } from '../../service/http-abstract-service';
import { FailedTxDto, ReportDayEndDto, ReportDto } from './dto';


@Injectable({
	providedIn: 'root'
})
export class HttpReportDayEndService extends AbstractHttpService {

	constructor(http: HttpClient) {
		super(http, '/report');
	}

	getAll(from: Date, to: Date, kioskId: number): Observable<ReportDto> {
		var search = {
			reportType: 'DayEndReport',
			from: from, 
			to: to, 
			kioskId: kioskId
		}
		return super.post(`/get`, search);
	}

	getReportFile(reportId: number): Observable<Blob> {
		return super.doDownloadFileSimple(`/DayEndReport/${reportId}/download`);
	}
}
